import React from 'react'
import { css } from 'aphrodite'
import { Row } from 'reactstrap'

import style from './style'

import Perks from './partials/perks'
import Mission from './partials/mission'
import Signup from './partials/signup'
import Reviews from './partials/reviews'
import Slideshow from '../partials/Slideshow'

export class HomeScreen extends React.Component {
  constructor() {
    super()

    this.state = {
      welcomeText: {
        topOffset: 0,
        list: [
          { active: true, text: `VPP Gaming Network` },
          { active: false, text: `premium ad exposure` },
          { active: false, text: `the future` }
        ]
      },
      stats: [
        { number: 0, target: 50, title: `Million Page Views Per Month` },
        { number: 0, target: 500, title: `Million Ads Server` },
        { number: 0, target: 300, title: `Publishers And More` },
        { number: 0, target: 2500, title: `Alexa Ranking` }
      ]
    }
  }

  componentDidMount() {
    this.statsAnimationTimeout()
    this.welcomeTextTimeout()
  }

  statsAnimationTimeout() {
    setTimeout(() => {
      this.setState({
        ...this.state,
        stats: this.state.stats.map(item => ({
          ...item,
          number:
            item.number < item.target
              ? item.number + item.target * 0.1
              : item.target
        }))
      })

      if (!this.state.stats.every(item => item.number === item.target)) {
        this.statsAnimationTimeout()
      }
    }, 50)
  }

  welcomeTextTimeout() {
    const offset =
      this.state.welcomeText.topOffset >=
      (this.state.welcomeText.list.length - 1) * 42
        ? 0
        : this.state.welcomeText.topOffset + 42
    setTimeout(() => {
      this.setState({
        ...this.state,
        welcomeText: {
          ...this.state.welcomeText,
          topOffset: offset,
          list: this.state.welcomeText.list.map((item, index) => ({
            ...item,
            active: !!(Math.round(offset / 42) === index)
          }))
        }
      })

      this.welcomeTextTimeout()
    }, 1000)
  }

  render() {
    return [
      <Row key={0} className={`d-none d-md-flex`}>
        <Slideshow
          width={`100%`}
          height={`500px`}
          type={`image`}
          timeout={5000}
          slides={[
            {
              imageUrl: `/images/bg/wall.jpg`,
              // component: ( <h1> test</h1> ),
              content: {
                left: [
                  { type: 'header', content: `LOOKING FOR NEW` },
                  { type: 'subheader', content: `ADVERTISING` },
                  { type: 'subheader', content: `SOLUTION?` },
                  {
                    type: 'button',
                    url: '/login',
                    title: `Login`,
                    color: `white`
                  },
                  {
                    type: 'button',
                    url: '/signup',
                    title: `Sign Up`,
                    color: `red`
                  }
                ],
                right: [
                  {
                    type: 'image',
                    animation: 'topToBottom',
                    src: `/images/home/monitorad.png`
                  }
                ]
              }
            },
            {
              imageUrl: `/images/slider/insurgencybg.jpg`,
              content: {
                left: [
                  { type: 'header', content: `World Wide Advertising` },
                  { type: 'subheader', content: `Net 01` },
                  { type: 'subheader', content: `Great CPM` },
                  {
                    type: 'button',
                    url: '/login',
                    title: `Login`,
                    color: `white`
                  },
                  {
                    type: 'button',
                    url: '/signup',
                    title: `Sign Up`,
                    color: `red`
                  }
                ],
                right: [
                  {
                    type: 'image',
                    animation: 'topToBottom',
                    src: `/images/light-logo.svg`
                  }
                ]
              }
            }
          ]}
        />
      </Row>,
      <Row key={1} tag="section" className={css(style.main.section)}>
        <Perks welcomeText={this.state.welcomeText} />
      </Row>,
      <Row
        key={2}
        tag="section"
        className={css(style.main.section, style.mission.section)}
      >
        <Mission stats={this.state.stats} />
      </Row>,
      <Row key={3} tag="section" className={css(style.signup.section)}>
        <Signup />
      </Row>,
      <Row key={4} tag="section" className={css(style.main.section)}>
        <Reviews />
      </Row>
    ]
  }
}

export default HomeScreen



// WEBPACK FOOTER //
// ./src/components/Home/index.js